import { render, staticRenderFns } from "./JobIntro.vue?vue&type=template&id=6167977f&scoped=true&"
import script from "./JobIntro.vue?vue&type=script&lang=js&"
export * from "./JobIntro.vue?vue&type=script&lang=js&"
import style0 from "./JobIntro.vue?vue&type=style&index=0&id=6167977f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6167977f",
  null
  
)

export default component.exports